<template>
  <div class="company form-horizontal block">
    <div class="settings-company__container block">
      <component :is="`additional-${getProcessName}`" v-if="getProcessName" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
const AdditionalMars = () =>
  import(/* webpackChunkName: "additinal-mars" */ '@/process/mars/components/settings/SettingsAdditionalView');
const AdditionalAlrosa = () =>
  import(/* webpackChunkName: "additinal-alrosa" */ '@/process/alrosa/components/settings/SettingsAdditionalView');

export default {
  name: 'SettingsAdditional',

  components: {
    AdditionalMars,
    AdditionalAlrosa
  },

  computed: {
    ...mapGetters('process', ['getProcessName'])
  }
};
</script>

<style lang="scss" scoped>
.settings {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;

  &__wrapper {
    padding-bottom: 100px;
  }
}

.company {
  width: 380px;
  margin-right: auto;
  margin-bottom: 50px;

  &.block {
    width: 100%;
  }
}

.settings-company__container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
  flex-direction: column;
  width: 380px;

  &.block {
    width: 100%;
  }
}

::v-deep .additional {
  &__field {
    margin-bottom: 10px;
  }

  &__field-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .vinput {
      flex: 1;
    }
    .vbutton {
      margin-left: 5px;
    }
  }

  &__block-label {
    margin-bottom: 7px;
  }
}
</style>
